import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Sink} from "../types/Sink";

export const useGetSinks = (dealerID: number, prodQteGrpID: number, zipCode: string) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-pro-sinks', prodQteGrpID, dealerID, zipCode],
        queryFn: async () => await apiClient.get('ee-pro/sinks?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&zipCode=' + zipCode) as Sink[],
        enabled: prodQteGrpID > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
